import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';

@Component({
  selector: 'search-barcode-location',
  templateUrl: './search-barcode-location.component.html',
  styleUrls: ['./search-barcode-location.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SearchBarcodeLocationComponent,
      multi: true
    }
  ]
})
export class SearchBarcodeLocationComponent implements OnInit, ControlValueAccessor {

  @ViewChild('input', {static: true}) input: ElementRef;

  // inputs
  @Input() errors: any;
  @Input() fieldError: string;
  @Input() isDisabled: boolean;
  @Input() isInvalid: boolean;
  @Input() additionalProcessing: boolean;
  @Input() label: string;
  @Input() isSubmitted: boolean;
  @Input() maxlength: string;
  @Input() placeholder: string = '';
  @Input() class: string;
  @Input() required: boolean;
  @Input() currentLocationRefCode: any;

  @Output() findLocation: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChangeLocation: EventEmitter<any> = new EventEmitter<any>();

  public formProcessing: boolean = false;
  public value: string;
  public changed: (value: string) => void;
  public touched: () => void;
  onChangeSubs: Subscription[] = [];

  constructor(
    private _fb: UntypedFormBuilder,
    private _apiSvc: ApiService,
    private _toastMsgSvc: ToastMessageService
  ) { }

  // from group
  form: UntypedFormGroup = this._fb.group({
    locationSearch: [null]
  })

  private locationsEp = `${this._apiSvc.endpoints.inventory}/api/Location`;

  ngOnInit(): void {
    
    this.form.controls.locationSearch.valueChanges
      .pipe(debounceTime(2000))
      .subscribe((value) => {
        if (value) {
          this.formProcessing = true;
          this.searchLocations(this.form.get("locationSearch").value);
        }
      });

      this.form.controls.locationSearch.valueChanges
      .subscribe( val => {
        this.onTextChange(val);
      }
    );
  }

  clearLocation(): void {
    this.form.get('locationSearch').setValue(null);
    this.onChangeLocation.emit();
  }

  private searchLocations(locationRefCode: string) {
    if (locationRefCode) {
      this._apiSvc.search(this.locationsEp, { Filter: `LocationRefCode~eq~'` + locationRefCode.trim() + `'`, sort: 'LocationRefCode-asc' })
        .subscribe((res: any) => {
          let locationResult: any = null;
          if (res && res.Data[0]) {
            locationResult = res.Data[0];
            this.showToastMessage('Location found!');
          }
          else {
            this.clearLocation();
            this.showToastMessage('Location not found!', 'error');
          }

          this.onLocationSearchResult(locationResult);
          this.formProcessing = false;
        });
    }
  }

  onLocationSearchResult(result: any): void {
    this.findLocation.emit(result)
  }
  
  showToastMessage(msg: string, msgType: string = 'success') {
    this._toastMsgSvc.send({
      duration: msgType === 'error' ? 6000 : 3000,
      type: msgType,
      message: msg,
      icon: 'check_circle_outline'
    });
  }

  onTextChange(value: string) {
    this.value = value;
    this.changed(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.changed = fn;
  }

  registerOnTouched(fn: () => void) {
    this.touched = fn;
  }

  setDisabledState(disabled: boolean): void {
    if (disabled) {
      this.form.disable();
    }
    else {
      this.form.enable();
    }
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }
  
}
